import { Checkbox } from "../../checkbox";
import { createColumnHelper } from "./column-helper";
import { createMeta } from "./handlers";

const columnHelper = createColumnHelper<{ id: string }>();

export const RowSelectionHandler = [
	columnHelper.display({
		id: "row-selection",
		header: ({ table }) => {
			if (!table.options.enableMultiRowSelection) return null;
			return (
				<Checkbox
					value={table.getSelectedRowModel().rows.length > 0}
					isIndeterminate={table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected()}
					onChange={() => {
						const selectableRows = table.getRowModel().rows.filter((row) => row.getCanSelect());
						const isAllSelected = table.getIsAllRowsSelected();
						for (const row of selectableRows) {
							row.toggleSelected(!isAllSelected);
						}
					}}
				/>
			);
		},
		cell: ({ row }) => {
			return (
				<Checkbox
					value={row.getIsSelected()}
					isDisabled={!row.getCanSelect()}
					onChange={(value) => row.toggleSelected(value)}
				/>
			);
		},
		size: 35,
		meta: createMeta({
			hideOptions: true,
		}),
	}),
];
